import { render, staticRenderFns } from "./ProfileMenu.vue?vue&type=template&id=2438ed58&scoped=true"
import script from "./ProfileMenu.vue?vue&type=script&lang=js"
export * from "./ProfileMenu.vue?vue&type=script&lang=js"
import style0 from "./ProfileMenu.vue?vue&type=style&index=0&id=2438ed58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2438ed58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VIcon,VList,VListItem,VListItemIcon,VListItemTitle,VMenu,VSubheader,VTooltip})
